import type {LaunchResponse} from '@yandex-delivery/types/schemas/services/cargo-corp/docs/yaml/definitions/launch'
import React, {type PropsWithChildren, createContext, useContext} from 'react'

export type Point = [number, number]

export type AppConfig = {
  accountUrl: string
  countryCode: string
  getPhoneMask?: (value?: string, defaultMask?: string) => string
  lang: string
  launch?: LaunchResponse
  location: Point
  passportApiHost: string
  passportAppID?: string
  passportHost: string
  trustHost: string
  version: string
  /** Функция для валидации номера телефона */
  checkIsValidPhone: (phone?: string) => boolean
  /** Функция для приведения номера телефона к форме, принимаемой бэком (например, 7 заменить на 8 в начале номера) */
  normalizePhone: (phone: string) => string
  currencySign: string
  offerID?: string
  getRegistrationUrl: (params?: Record<string, string>) => string
  getPassportUrl: (path: string) => string
  clientId?: string
  yandexuid?: string
  initialProps?: {
    zonePoint: Point
    zoneName?: string
    from?: Point
    tariff?: string
    to?: Point
  }
}

type ConfigProviderProps = PropsWithChildren<AppConfig>

export const ConfigContext = createContext<AppConfig | null>(null)

export const ConfigProvider = ({children, ...contextValue}: ConfigProviderProps) => (
  <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>
)

export function useConfigContext(): AppConfig {
  const context = useContext(ConfigContext)

  if (!context) {
    throw new Error('useConfigContext has to be used within ConfigProvider')
  }

  return context
}
